import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const REFRESH_INTERVAL = 5 * 60 * 1000;
let cachedData = null;
let fetchedAt = 0;
let pendingRequest = null;

function loadStockData() {
  if (cachedData && Date.now() - fetchedAt < REFRESH_INTERVAL) {
    return Promise.resolve(cachedData);
  }
  if (!pendingRequest) {
    pendingRequest = api.get("/widgets/stock")
      .then(({ data }) => {
        cachedData = data;
        fetchedAt = Date.now();
        return data;
      })
      .catch(() => cachedData || { items: [], updated_at: null })
      .finally(() => { pendingRequest = null; });
  }
  return pendingRequest;
}

export default function useStockData() {
  const [data, setData] = useState(cachedData || { items: [], updated_at: null });

  useEffect(() => {
    let active = true;
    const refresh = async () => {
      const next = await loadStockData();
      if (active) setData(next);
    };

    refresh();
    const interval = setInterval(refresh, REFRESH_INTERVAL);
    return () => {
      active = false;
      clearInterval(interval);
    };
  }, []);

  return data;
}
